import React, { useEffect, useState } from 'react'
import s from './RouteHighlighter.less'

const RouteHighlighter = ({ selectedRouteDomRef, notify }) => {
  const [top, setTop] = useState(0)
  const [height, setHeight] = useState(0)

  const getTop = () => selectedRouteDomRef?.current?.offsetTop

  const getHeight = () => selectedRouteDomRef?.current?.offsetHeight ?? 0

  const update = () => {
    setTop(getTop())
    setHeight(getHeight())
  }

  useEffect(() => {
    update()
  }, [])

  useEffect(() => {
    if (selectedRouteDomRef && getHeight() !== 0) {
      update()
    }
  }, [selectedRouteDomRef, notify])

  return <div className={s.RouteHighlighter} style={{ top, height }} />
}
export default RouteHighlighter
